module.exports = __webpack_public_path__ + "static/media/SO.dc2fb9be.svg";